import { Action } from 'redux'
import { DetailPageActionTypes } from './constants'
import { StringId } from '../components/localizer/stringId'
import { MessageTypes } from '@dvui'

export interface ICreateBanner extends Action {
  type: typeof DetailPageActionTypes.CreateBanner
  payload: {
    stringId?: StringId
    string?: string
    type: MessageTypes
  }
}

export interface IClearBanner extends Action {
  type: typeof DetailPageActionTypes.ClearBanner
}

export const createBanner = (
  type: MessageTypes,
  stringId?: StringId,
  string?: string
): ICreateBanner => ({
  type: DetailPageActionTypes.CreateBanner,
  payload: {
    stringId,
    string,
    type,
  },
})

export const clearBanner = () => ({
  type: DetailPageActionTypes.ClearBanner,
})
